module.exports = __webpack_public_path__ + "b111c44ad076945213b75dc8ec0b9ee4.svg";